/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { action, makeObservable, observable } from 'mobx';

import type React from 'react';

import { WizardStateStore } from '../../stores';

import type { PageWizardProps, PageWizardStep } from '../interfaces';

export type PanelRenderer = (hide: () => void) => React.ReactNode;

export class PageWizardStore<T> {
    baseStore: WizardStateStore<T>;
    data: T;
    private steps: PageWizardStep<T>[];

    @observable isPanelOpened = false;

    panelRenderer: PanelRenderer;

    constructor(props: PageWizardProps<T>) {
        this.baseStore = new WizardStateStore<T>({
            title: props.title,
            isEdit: props.isEdit,
            steps: props.steps,
            data: props.data,
            onFinish: props.onFinish,
            deactivate: props.deactivate,
            closeMessageText: props.closeMessageText,
            closeMessageOkButtonText: props.closeMessageOkButtonText,
            closeMessageCancelButtonText: props.closeMessageCancelButtonText,
        });

        this.steps = props.steps;
        this.data = props.data;
        makeObservable(this);
    }

    @action.bound
    openPanel(panelRenderer: PanelRenderer): void {
        this.panelRenderer = panelRenderer;
        this.isPanelOpened = true;
    }

    @action.bound
    closePanel(): void {
        this.isPanelOpened = false;
    }

    setLoading(loading: boolean): void {
        this.baseStore.setLoading(loading);
    }

    setPending(pending: boolean): void {
        this.baseStore.setPending(pending);
    }
}
